import { render } from "./allsales.vue?vue&type=template&id=7911b0ef&scoped=true"
import script from "./allsales.vue?vue&type=script&lang=js"
export * from "./allsales.vue?vue&type=script&lang=js"

import "./allsales.vue?vue&type=style&index=0&id=7911b0ef&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7911b0ef"]])

export default __exports__